import { render, staticRenderFns } from "./OrderInlineDetail.vue?vue&type=template&id=353b0bed&scoped=true&lang=pug"
import script from "./OrderInlineDetail.vue?vue&type=script&lang=ts"
export * from "./OrderInlineDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrderInlineDetail.vue?vue&type=style&index=0&id=353b0bed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b0bed",
  null
  
)

export default component.exports